import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

@Injectable({
  providedIn: 'root'
})
export class RateService {
  private readonly orderListApi = '/api/reservation_order/list';

  private readonly rateDetailApi = 'api/reservation_comment/detail';
  private readonly sendRateApi = 'api/reservation_comment/send_comment';
  private readonly sendReplyApi = 'api/reservation_comment/send_reply';
  private readonly replaceDynContentApi = 'api/reservation_comment/replace_dynamic_contents';
  private readonly completeCommentApi = '/api/reservation_comment/complete';

  constructor(private http: HttpClient) { }

  fetchRateOrderList (params) {
    const query = new HttpParams({
      fromObject: params
    });
    return this.http.get(this.orderListApi, { params: query }) as Observable<any>;
  }

  fetchRateDetail (params) {
    const query = new HttpParams({
      fromObject: params
    })
    return this.http.get(this.rateDetailApi, { params: query }) as Observable<any>;
  }

  sendRate (params) {
    return this.http.post(this.sendRateApi, params) as Observable<any>;
  }

  sendReply (params) {
    return this.http.post(this.sendReplyApi, params) as Observable<any>;
  }

  replaceDynContent (params) {
    return this.http.post(this.replaceDynContentApi, params) as Observable<any>;
  }

  setCommentComplete (params) {
    return this.http.post(this.completeCommentApi, params) as Observable<any>;
  }
}
